import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  h2 {
    text-align: center;
  }
  ul {
    list-style: none;
    li {
      text-align: center;
      a {
        text-align: center;
        img {
          width: 2rem;
          margin: auto;
        }
      }
    }
  }
`;
